import * as React from 'react';
import { cn } from '@/lib/utils';
import { ChevronLeft } from 'lucide-react';

export interface MobileNavbarProps {
  title: string;
  left?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
}

/**
 * iOS 風格導航欄
 * 用於手機 App 的頂部導航
 */
export function MobileNavbar({
  title,
  left,
  right,
  className,
}: MobileNavbarProps) {
  return (
    <nav
      className={cn(
        'sticky top-0 z-40 flex h-14 items-center justify-between border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 px-4 safe-area-top',
        className
      )}
    >
      <div className="flex flex-1 items-center justify-start">
        {left || <div className="w-16" />}
      </div>
      <div className="flex flex-1 items-center justify-center">
        <h1 className="text-lg font-semibold">{title}</h1>
      </div>
      <div className="flex flex-1 items-center justify-end">
        {right || <div className="w-16" />}
      </div>
    </nav>
  );
}

/**
 * iOS 風格返回按鈕
 */
export interface MobileNavbarBackButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
}

export function MobileNavbarBackButton({
  label = '返回',
  className,
  ...props
}: MobileNavbarBackButtonProps) {
  return (
    <button
      className={cn(
        'flex items-center gap-1 text-primary active:opacity-70',
        className
      )}
      {...props}
    >
      <ChevronLeft className="h-5 w-5" />
      <span className="text-base">{label}</span>
    </button>
  );
}
